import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syssh } from '../entity/Syssh-angular';

export interface SysshData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number;     SH001: string;            // 程式代號 20     SH002: string;            // 名稱 60     SH003: string;            // 網址 255     SH004: string;            // 備註 255     SH005: string;            // 流程圖/圖檔 0 先用附件系統. 說明檔    SH006: string;            // 類型 1 [DEF:"1"]  1:網頁 2:圖檔 3:文件檔  4:html 5:markdown    SH007: string;            // 保留 4 序號    SH008: string;            // 文管代號 10 WK008 DocID     join MTR.WJ001    SH009: string;            // 版次 3 WK009 Revision  join MTR.WJ002    SH010: string;            // 功能簡介 255     SH011: string;            // 功能分類 12 EX:基本資料 收銀單據    SH012: string;            // 序號 4     SH013: string;            // 建檔者代號 10 PACKAGE:保留給套裝    SH014: string;            // 用於系統 20 全部-收銀-客製-庫存-發票-會計-簽核    SH015: string;            // 生效碼 1 [DEF:"N"]    SH016: string;            // 客製程式碼 1 [DEF:"N"]    SH017: string;            // 說明 0     SH018: string;            // 註記碼 1 [DEF:"N"]    SH019: string;            // html內容 0 }


@Injectable({
  providedIn: 'root'
})
export class SysshServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syssh(); 
    this.entityType.type = EntityType.data;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
        SH001 : '程式代號' , SH002 : '名稱' , SH003 : '網址' , SH004 : '備註' , SH005 : '流程圖/圖檔' , SH006 : '類型' , SH008 : '文管代號' , SH009 : '版次' , SH010 : '功能簡介' , SH011 : '功能分類' , SH012 : '序號' , SH013 : '建檔者代號' , SH014 : '用於系統' , SH015 : '生效碼' , SH016 : '客製程式碼' , SH017 : '說明' , SH018 : '註記碼' , SH019 : 'html內容'  }; 

    this.fieldNames = 'SH001,SH002,SH003,SH004,SH005,SH006,SH008,SH009,SH010,SH011,SH012,SH013,SH014,SH015,SH016,SH017,SH018,SH019' ;
    this.fieldLengths = {SH001 : 20 ,SH002 : 60 ,SH003 : 255 ,SH004 : 255 ,SH005 : 0 ,SH006 : 1 ,SH008 : 10 ,SH009 : 3 ,SH010 : 255 ,SH011 : 12 ,SH012 : 4 ,SH013 : 10 ,SH014 : 20 ,SH015 : 1 ,SH016 : 1 ,SH017 : 0 ,SH018 : 1 ,SH019 : 0 } ;
    this.columnDefs = [
      { field: "SH011", headerName: "功能分類",headerTooltip: "",width:166,cellDataType: "text", },
      { field: "SH019", headerName: "html內容",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "SH018", headerName: "註記碼",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "SH017", headerName: "說明",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "SH016", headerName: "客製程式碼",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "SH015", headerName: "生效碼",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "SH014", headerName: "用於系統",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "SH013", headerName: "建檔者代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "SH012", headerName: "序號",headerTooltip: "",width:102,cellDataType: "text", },
      { field: "SH001", headerName: "程式代號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "SH010", headerName: "功能簡介",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "SH009", headerName: "版次",headerTooltip: "",width:94,cellDataType: "text", },
      { field: "SH008", headerName: "文管代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "SH006", headerName: "類型",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "SH005", headerName: "流程圖/圖檔",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "SH004", headerName: "備註",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "SH003", headerName: "網址",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "SH002", headerName: "名稱",headerTooltip: "",width:250,cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSSH' ;
    this.isSys =true; 
    this.sqlSelect = `SELECT SYSSH.*  FROM SYSSH` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY SH001,SH013` ;
    this.keyFields = ['SH001','SH013'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = ['SH001','SH013'];
    this.seqField = 'SH012' ;
    this.seqFieldLength = 4 ;
  }
  override async validateItem(item: Syssh): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syssh): Promise<Syssh> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

